import { paths } from "@shared-core/routing/routes";
import type { PortalLandingPage } from "@shared-core/domain/portalSignIn";
import type { PortalSignInOutcome } from "@shared-core/data/customer-portal-access-types";

/** Where each page of the sign-in landing lives. `scenario` names a review fixture (mock build only). */
export function landingPagePath(
  page: PortalLandingPage,
  scenario?: string,
  blockedCustomerId?: string,
): string {
  switch (page) {
    case "welcome":
      return paths.portalWelcome({ scenario });
    case "choose_customer":
      return paths.portalChooseCustomer({ scenario });
    case "no_access":
      return paths.portalNoAccess({ scenario });
    case "customer_blocked":
      return paths.portalCustomerBlocked({
        scenario,
        customer: blockedCustomerId,
      });
  }
}

/** Where a sign-in outcome is shown: its own page, or (`ready`) the portal itself. */
export function outcomePath(
  outcome: PortalSignInOutcome,
  scenario?: string,
): string {
  return outcome.kind === "ready"
    ? paths.portalOrders()
    : landingPagePath(outcome.kind, scenario);
}
